import { Array } from "@siteimprove/alfa-array";
import { Function, Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { PseudoElementSelector } from "./pseudo-element.js";
const { map, separatedList } = Parser;
/**
 * {@link https://drafts.csswg.org/css-shadow-parts-1/#part}
 */
export class Part extends PseudoElementSelector {
    static of(idents) {
        return new Part(Array.from(idents));
    }
    _idents;
    constructor(idents) {
        super("part");
        this._idents = idents;
    }
    get idents() {
        return this._idents;
    }
    *[Symbol.iterator]() {
        yield this;
    }
    equals(value) {
        return value instanceof Part && Array.equals(value._idents, this._idents);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            idents: Array.toJSON(this._idents),
        };
    }
    toString() {
        return `::${this.name}(${this._idents})`;
    }
}
(function (Part) {
    Part.parse = map(Function.parse("part", separatedList(Token.parseIdent(), Token.parseWhitespace)), ([_, idents]) => Part.of(idents));
})(Part || (Part = {}));
//# sourceMappingURL=part.js.map